module.exports = __webpack_public_path__ + "static/media/E_SDG_Icons-14.61808ca2.jpg";